<template>
  <div style="margin: 16px 24px 0;">
    <el-form ref="formRef"  label-width="auto" label-position="right">
      <el-form-item label="天数：">
        <el-input v-model="dayNum" placeholder="请输入整数" />
        <p style="font-size: 12px; color: red">*允许输入负数，负数则代表扣罚对应的天数</p>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="submit" v-loading="submitLoading">确定</el-button>
    </div>
  </div>
</template>

<script>
import { intReg } from '@/assets/shared/reg-constant'
import {postFormData} from "@/api/api";
import {updateVipUserExpire} from "@/api/url";
export default {
  name: "UserUpdateDialog",
  props: {
    value: Object
  },
  data() {
    return {
      id: this.value.id,
      dayNum: '',
      submitLoading: false
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },
    submit() {
      if(!this.dayNum) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '天数不能为空',
          type: 'warning'
        });
        return;
      }
      if(!intReg.test(this.dayNum)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '天数请输入整数',
          type: 'warning'
        });
        return;
      }
      this.submitLoading = true
      let param = {}
      param['id'] = this.id;
      param['type'] = 1;
      param['day'] = this.dayNum;
      postFormData(updateVipUserExpire, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.submitLoading = false
      })
    }
  }
}
</script>

<style scoped>

</style>
